import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import {
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  CardBody,
  Card,
  TabPane,
  TabContent
} from 'reactstrap';
import classnames from 'classnames';
import TenantInfo from './TenantInfo/TenantInfo';
import CoverLetter from './CoverLetter/CoverLetter';
import SampleQuote from './SampleQuote/SampleQuote';
import EOIPricing from './EOIPricing/EOIPricing';

class Settings extends Component {
  constructor(props) {
    super(props);

    this.toggleTab = this.toggleTab.bind(this);
    this.state = {
      activeTab: '1'
    };
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Settings</title>
        </Helmet>
        <div>
          <h3>Settings</h3>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === '1',
                          pointer: true
                        })}
                        onClick={() => {
                          this.toggleTab('1');
                        }}
                      >
                        Tenant Info
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === '2',
                          pointer: true
                        })}
                        onClick={() => {
                          this.toggleTab('2');
                        }}
                      >
                        Condo Questionnaire
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === '3',
                          pointer: true
                        })}
                        onClick={() => {
                          this.toggleTab('3');
                        }}
                      >
                        Sample Quote
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === '4',
                          pointer: true
                        })}
                        onClick={() => {
                          this.toggleTab('4');
                        }}
                      >
                        EOI Pricing
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                      <div
                        className={'p-3 border-left border-right border-bottom'}
                      >
                        <Row>
                          <Col xs={12}>
                            <TenantInfo />
                          </Col>
                        </Row>
                      </div>
                    </TabPane>
                    {this.state.activeTab === '2' && (
                      <TabPane tabId="2">
                        <div
                          className={
                            'p-3 border-left border-right border-bottom'
                          }
                        >
                          <Row>
                            <Col xs={12}>
                              <CoverLetter />
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                    )}

                    {this.state.activeTab === '3' && (
                      <TabPane tabId="3">
                        <div
                          className={
                            'p-3 border-left border-right border-bottom'
                          }
                        >
                          <Row>
                            <Col xs={12}>
                              <SampleQuote />
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                    )}

                    {this.state.activeTab === '4' && (
                      <TabPane tabId="4">
                        <div
                          className={
                            'p-3 border-left border-right border-bottom'
                          }
                        >
                          <Row>
                            <Col xs={12}>
                              <EOIPricing />
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                    )}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    );
  };
}
export default Settings;
